"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
function BlogPostsConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-96 rounded-xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground mb-4">Failed to load blog posts.</p>
        <Button onClick={refetch} variant="outline">
          Retry
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground">No blog posts to display.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="overflow-hidden transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium">
          {post.featuredImage && <div className="aspect-[16/10] overflow-hidden">
              <img src={post.featuredImage} alt={post.title} fetchpriority="high" className="size-full object-cover transition-transform duration-[var(--duration-slow)] hover:scale-105" />
            </div>}

          <CardContent className="space-y-3">
            <h3 className="text-xl font-semibold text-foreground leading-tight line-clamp-2">
              {post.title}
            </h3>

            {post.excerpt && <p className="text-sm text-muted-foreground line-clamp-3">
                {post.excerpt.replace(/<[^>]*>/g, "")}
              </p>}
          </CardContent>

          <CardFooter className="pt-0">
            {post.link && <Link to={post.link} className="group inline-flex items-center gap-2 text-sm font-semibold text-primary hover:text-primary-hover transition-colors duration-[var(--duration-fast)]">
                <span className="relative">
                  Read More
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-secondary transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] translate-y-0 group-hover:translate-y-0.5" />
                </span>
                <ArrowRight className="size-4 transition-transform duration-[var(--duration-fast)] group-hover:translate-x-1" />
              </Link>}
          </CardFooter>
        </Card>)}
    </div>;
}
export default function BlogPosts() {
  return <section className="py-16 px-4 bg-primary-light/30">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4">
            Latest From Our Blog
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Stay informed with helpful tips, dental care advice, and the latest news from Alpha Dental.
          </p>
        </div>

        <PostsProvider wp_query={{
        per_page: 6,
        order: "desc",
        orderby: "date"
      }}>
          <BlogPostsConsumer />
        </PostsProvider>
      </div>
    </section>;
}